// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pp-app[data-v-11e5a470]{--pp-primary-disabled-button-bg:#545454;display:inline-block}", ""]);
// Exports
module.exports = exports;
